import { useGetUserProfileInfoQuery } from '../../Settings/MyProfile/queries';

export function useGetUserRole() {
    const { data: userProfileData, isLoading: isUserRoleLoading } = useGetUserProfileInfoQuery();
    const currentUserRole = userProfileData?.data.role;

    return { currentUserRole, isUserRoleLoading };
}
